// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"a2c79c7e7d--checkbox--oMeNF","box":"a2c79c7e7d--box--aD_nX","label":"a2c79c7e7d--label--iT_qr"};